const PaymentProvider = {
    ASAAS: 'ASAAS',
    CELCOIN: 'CELCOIN'
}

export default PaymentProvider;
